// extracted by mini-css-extract-plugin
export default {"container":"nF-z","innerContainer":"oF-z","multipleLines":"pF-z","heading":"qF-z","content":"rF-z","linkColor":"sF-z"};